import useMediaQuery from "~/common/hooks/useMediaQuery";
import { Trans, useTranslation } from "react-i18next";
import { MEDIA_QUERY_MIN_DESKTOP_S } from "~/common/utils/screenSizes";
import { styled } from "~/common/mui";

type RegisterFreeSuccessPageViewProps = {
  imageSrc?: string;
};

const DEFAULT_REGISTRATION_SUCCESS_IMG_URL = "/_ui/responsive/theme-alpha/images/registration-success.png";

export const RegisterFreeSuccessPageView = ({
  imageSrc = DEFAULT_REGISTRATION_SUCCESS_IMG_URL,
}: RegisterFreeSuccessPageViewProps) => {
  const { i18n } = useTranslation();
  const isDesktop = useMediaQuery(MEDIA_QUERY_MIN_DESKTOP_S);

  return (
    <RegisterSuccessRoot className={"register-success " + (isDesktop ? "register-desktop" : "register-mobile")}>
      <RegisterSuccessMessage className="register-success__message">
        <Trans i18n={i18n} i18nKey={"page.registerSuccess.message"} />
      </RegisterSuccessMessage>
      <RegisterSuccessImage className="register-success__image" src={imageSrc} />
    </RegisterSuccessRoot>
  );
};

const RegisterSuccessRoot = styled("div")({
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
});

const RegisterSuccessMessage = styled("h1")(({ theme }) => ({
  width: theme.spacing(78.75),
  ...theme.typography.displaySmall,
  marginTop: theme.spacing(7.5),
  textAlign: "center",
  ".register-mobile &": {
    ...theme.typography.titleLarge,
    margin: `0 0 ${theme.spacing(4)} 0`,
    width: "auto",
  },
}));

const RegisterSuccessImage = styled("img")(({ theme }) => ({
  width: theme.spacing(56),
  height: theme.spacing(40.125),
  marginTop: theme.spacing(7.5),
  marginBottom: theme.spacing(7.5),
  ".register-mobile &": {
    margin: 0,
    width: "80%",
    height: "auto",
  },
}));

export function createRegisterFreeSuccessPage(props?: RegisterFreeSuccessPageViewProps) {
  return <RegisterFreeSuccessPageView {...props} />;
}
